export enum CheckoutType {
    SERVICE_INVOICE_PURCHASE = 'SERVICE_INVOICE_PURCHASE',
    NO_FRAUD_PURCHASE = 'NO_FRAUD_PURCHASE',
    PAYLINK = 'PAYLINK',
    ADVANCE_INVOICE = 'ADVANCE_INVOICE',
}

export default CheckoutType;
